
import React from 'react';
import { cn } from "@/lib/utils";

interface NavbarContainerProps {
  scrolled: boolean;
  children: React.ReactNode;
}

const NavbarContainer = ({ scrolled, children }: NavbarContainerProps) => {
  return (
    <nav
      className={cn(
        "fixed top-0 left-0 right-0 transition-all duration-300 z-50",
        scrolled
          ? "bg-white/95 backdrop-blur-md shadow-md"
          : "bg-transparent"
      )}
    >
      <div className="container mx-auto px-6 flex items-center justify-between h-16">
        {children}
      </div>
    </nav>
  );
};

export default NavbarContainer;
